export default "__VITE_ASSET__gehUpj2Y__"